// extracted by mini-css-extract-plugin
export default {"centeringContainer":"K8e5u","separator":"IH8wI","container":"EM+z7"};